

import Swal from "sweetalert2";
import { dataConsultaRayos } from "../helpers/fetch";
import { saveAs } from 'file-saver';
import { Parser } from 'json2csv';
/**
 * Function to set information for the Redux
 * @param {string} star -Date start
 * @param {string} end -End start
 * @param {string} point -Name of the point
 * @param {object} data -Object of request information
 */


/**
 * Get information data for the report
 * @param {string} star -Date start
 * @param {string} end  -End start
 * @param {number} uid -Number ID of the client
 */
export const getInformationdateR = (star, end, format, uid) => {
    return async (dispatch) => {

        // Mostrar ventana de carga
        Swal.fire({
            title: 'Generando reporte...',
            text: 'Por favor espera',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            const body = await dataConsultaRayos(
                {
                    solicitud: 'historicoRayos',
                    fecha_inicial: star,
                    fecha_final: end,
                    idCliente: uid
                },
                'POST'
            );

            Swal.close();

            if (!body || body.length === 0) {
                return Swal.fire('', 'No se genera reporte para la fecha seleccionada', 'info');
            }

            if (format === 'csv') {
                // Generar CSV
                const parser = new Parser();
                const csv = parser.parse(body);
                const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
                const fileName = `historico_rayos_${star}_a_${end}.csv`;
                saveAs(blob, fileName);
            }

            if (format === 'kml') {
                // Generar KML simple (puntos)
                let kml = `<?xml version="1.0" encoding="UTF-8"?>\n`;
                kml += `<kml xmlns="http://www.opengis.net/kml/2.2">\n<Document>\n`;

                body.forEach((entry, index) => {
                    const { fecha, tipo, corriente, error, altura } = entry;
                    const lat = parseFloat(entry.latitud || entry.latitude || entry.lat);  // ajusta según nombres reales
                    const lon = parseFloat(entry.longitud || entry.longitude || entry.lon); 
                    if (!isNaN(lat) && !isNaN(lon)) {
                        kml += `
                        <Placemark>
                        <name>Punto ${index + 1}</name>
                        <description><![CDATA[
                            <table border="1" cellpadding="4" cellspacing="0">
                            <tr><td><b>Fecha</b></td><td>${fecha}</td></tr>
                            <tr><td><b>Altura</b></td><td>${altura}</td></tr>
                            <tr><td><b>Tipo</b></td><td>${tipo}</td></tr>
                            <tr><td><b>Corriente</b></td><td>${corriente}</td></tr>
                            <tr><td><b>Error</b></td><td>${error}</td></tr>
                            </table>
                        ]]></description>
                        <Point><coordinates>${lon},${lat},0</coordinates></Point>
                        </Placemark>`;
                    }
                });

                kml += `\n</Document>\n</kml>`;

                const blob = new Blob([kml], { type: 'application/vnd.google-earth.kml+xml' });
                const fileName = `historico_rayos_${star}_a_${end}.kml`;
                saveAs(blob, fileName);
            }

            return Swal.fire('Correcto', 'Reporte generado y descargado', 'success');

        } catch (error) {
            Swal.close();
            console.error('Error al generar archivo:', error);
            return Swal.fire('Error', 'No se pudo generar el archivo', 'error');
        }
    };
};
